// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Float = require("@rescript/runtime/lib/js/Stdlib_Float.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let QueryParamUtils = require("../../common/QueryParamUtils.bs.js");
let PropertiesSearchMapViewport = require("./PropertiesSearchMapViewport.bs.js");

function fromUrl(params) {
  let match = params.get("bounds");
  let match$1 = QueryParamUtils.int(params, "zoom");
  if (match == null) {
    return;
  }
  if (match$1 === undefined) {
    return;
  }
  let match$2 = match.split(",").map(Stdlib_Float.fromString);
  if (match$2.length !== 4) {
    return;
  }
  let north = match$2[0];
  if (north === undefined) {
    return;
  }
  let east = match$2[1];
  if (east === undefined) {
    return;
  }
  let south = match$2[2];
  if (south === undefined) {
    return;
  }
  let west = match$2[3];
  if (west !== undefined) {
    return PropertiesSearchMapViewport.makeRequestViewport({
      north: north,
      east: east,
      south: south,
      west: west
    }, match$1);
  }
}

function boundsString(param) {
  let bounds = param.bounds;
  return [
    bounds.north,
    bounds.east,
    bounds.south,
    bounds.west
  ].map(value => value.toFixed(6)).join(",");
}

function key(viewport) {
  return boundsString(viewport) + `:` + viewport.zoomLevel.toString();
}

function write(params, viewport) {
  QueryParamUtils.setIfExists(params, "bounds", viewport, boundsString);
  QueryParamUtils.setIfExistsInt(params, "zoom", Stdlib_Option.map(viewport, viewport => viewport.zoomLevel));
}

exports.fromUrl = fromUrl;
exports.boundsString = boundsString;
exports.key = key;
exports.write = write;
/* QueryParamUtils Not a pure module */
